import { useState, useEffect, useRef } from 'react';

export const useTypingEffect = (text: string, speed: number = 50, onTextUpdate?: (text: string) => void) => {
  const [displayedText, setDisplayedText] = useState('');
  const [isTyping, setIsTyping] = useState(false);
  const intervalRef = useRef<NodeJS.Timeout | null>(null);

  useEffect(() => {
    if (!text) {
      setDisplayedText('');
      setIsTyping(false);
      return;
    }

    setIsTyping(true);
    setDisplayedText('');
    
    // Split text into words (preserve spaces and line breaks)
    const words = text.split(/(\s+)/);
    let currentWordIndex = 0;
    
    intervalRef.current = setInterval(() => {
      if (currentWordIndex < words.length) {
        const newText = words.slice(0, currentWordIndex + 1).join('');
        setDisplayedText(newText);
        onTextUpdate?.(newText);
        currentWordIndex++;
      } else {
        setIsTyping(false);
        onTextUpdate?.(text); // Final call when typing is complete
        if (intervalRef.current) {
          clearInterval(intervalRef.current);
        }
      }
    }, speed);

    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
    };
  }, [text, speed]); // Removed onTextUpdate from dependencies to prevent re-renders

  return { displayedText, isTyping };
};